export enum RegionIds {
    BritishColumbia = "bc",
    Alberta = "ab",
    Manitoba = "mb",
    NewBrunswick = "nb",
    NewfoundlandLabrador = "nl",
    NorthwestTerritories = "nt",
    NovaScotia = "ns",
    Nunavut = "nu",
    Ontario = "on",
    PrinceEdwardIsland = "pe",
    Quebec = "qb",
    Saskatchewan = "sk",
    Yukon = "yk",
    Alabama = "AL",
    Alaska = "AK",
    Arizona = "AZ",
    Arkansas = "AR",
    California = "CA",
    Colorado = "CO",
    Connecticut = "CT",
    Delaware = "DE",
    DistrictColumbia = "DC",
    Florida = "FL",
    Georgia = "GA",
    Guam = "GU",
    Hawaii = "HI",
    Idaho = "ID",
    Illinois = "IL",
    Indiana = "IN",
    Iowa = "IA",
    Kansas = "KS",
    Kentucky = "KY",
    Louisiana = "LA",
    Maine = "ME",
    MarshallIslands = "MH",
    Maryland = "MD",
    Massachusetts = "MA",
    Michigan = "MI",
    Minnesota = "MN",
    Mississippi = "MS",
    Missouri = "MO",
    Montana = "MT",
    NorthAmerica = "NA",
    Nebraska = "NE",
    Nevada = "NV",
    NewHampshire = "NH",
    NewJersey = "NJ",
    NewMexico = "NM",
    NewYork = "NY",
    NorthCarolina = "NC",
    NorthDakota = "ND",
    Ohio = "OH",
    Oklahoma = "OK",
    Oregon = "OR",
    Palau = "PW",
    Pennsylvania = "PA",
    PuertoRico = "PR",
    RhodeIsland = "RI",
    SouthCarolina = "SC",
    SouthDakota = "SD",
    Tennessee = "TN",
    Texas = "TX",
    Utah = "UT",
    Vermont = "VT",
    Virginia = "VA",
    Washington = "WA",
    WestVirginia = "WV",
    Wisconsin = "WI",
    Wyoming = "WY",
    Victoria = "AU-VIC",
}
